import {req, req2} from './Network';


// =================================================================
// 학습 관련 api
// =================================================================
// classResults - 차시 학습 결과 가져오기
export const getClassLessonStage = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/lessons/${body.lessonInfoId}/stages/${body.stageId}`,{params: { round: body.round}});
};

export const getClassLesson = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/lessons/${body.lessonInfoId}`);
};

export const getClassLastLesson = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}`);
};

export const getClassLastLessonId = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/lessons`);
};

// classResults - 숙제 학습 결과 가져오기
export const getClassLessonStageHomework = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/lessons/${body.lessonInfoId}/stages/${body.stageId}/homework`,{params: { round: body.round}});
};


export const getClassLessonHomework = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/lessons/${body.lessonInfoId}/homework`);
};

export const getClassLastHomeworkLessonInfo = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/homework`);
};

export const createHomework = (body) => {
  return req.post(`/v1/learnings/classes/homework`, body)
};

export const deleteHomework = (body) => {
  return req.put(`/v1/learnings/classes/homework`, body)
};

export const deleteHomeworkAll = (body) => {
  return req.delete(`/v1/learnings/classes/${body.classId}/homework`)
};

export const inAppCurriculums = () => { // 스테이지 커리큘럼 정보
  return req.get("/v1/curriculum/inappdata", {});
}

// classResults - 오늘의 학습 결과 가져오기

export const getClassDailyStudyChapter = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/daily-study/chapters/${body.chapterId}`, {})
}

export const getClassDailyStudyStage = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/daily-study/stages/${body.stageId}`, {})
}

export const getClassLevelChapter = (body) => {
  return req.get(`/v1/learnings/classes/${body.type}/${body.classId}`, {})
}

export const updateClassLevelChapter = (body) => {
  return req.put(`/v1/learnings/classes/${body.type}/${body.classId}/${body.level}/${body.supremeChapterSequence}/${body.chapterSequence}`, {})
}

export const getClassWeeklyLearningData = (body) => {
  return req.get(`/v1/learnings/classes/${body.classId}/weekly`, {  params: body.params})
}

export const getStudentWeeklyLearningData = (body) => {
  return req.get(`/v1/learnings/students/${body.studentId}/weekly`, {  params: body.params})
}

export const getStudentDailyLearningData = (body) => {
  return req.get(`/v1/learnings/students/${body.studentId}/daily`, {  params: body.params})
}

export const getStudentMonthlyLearningData = (body) => {
  return req.get(`/v1/learnings/students/${body.studentId}/monthly`, {  params: body.params})
}

// =================================================================
// 학급 관련 api
// =================================================================
/**
 * management - 클래스 생성 api
 * @param body
 * @returns ApiResponse<ClassResponse>
 */
export const makeClass = (body) => {
  return req.post(`/v1/classes`, body);
};

/**
 * management - 클래스 정보 가져오기 api
 * @param body
 * @returns ApiResponse<ClassesResponse>
 */
export const getClasses = (body) => {
  return req.get(`/v1/classes/teachers/${body.teacherId}`);
};

/**
 * management - 클래스 정보 수정하기 api
 * @param body
 * @returns ApiResponse<Void>
 */
export const updateClasses = (body) => {
  return req.put(`/v1/classes/teachers/${body.teacherId}`, body.request);
};

/**
 * 클래스 삭제 api
 * @param body
 * @returns ApiResponse<Void>
 */
export const deleteClasses = (body) => {
  return req.delete(`/v1/classes/teachers/${body.teacherId}/classes/${body.classId}`);
};

/**
 * management - 클래스 정보 수정하기 api
 * @param body
 * @returns ApiResponse<Void>
 */
export const updateMainClass = (body) => {
  return req.put(`/v1/classes/teachers/${body.teacherId}/mainClass/${body.classId}`);
};


/**
 * management - 학생 추가하기 api
 * @param body
 * @returns ApiResponse<StudentResponse>
 */
export const createStudent = (body) => {
  return req.post(`/v1/students`, body);
};

/**
 * students - 학생 리스트 가져오기 api
 * @param body
 * @returns ApiResponse<StudentsResponse>
 */
export const getStudents = (body) => {
  let sortBy = body.sortBy ? body.sortBy : '';
  let sortOrder = body.sortOrder ? body.sortOrder : '';
  let limit = body.limit ? body.limit : '';
  return req.get(`/v1/students/classes/${body.classId}?sortBy=${sortBy}&sortOrder=${sortOrder}&limit=${limit}`);
};

/**
 * students - 학생 정보 수정하기 api
 * @param body
 * @returns ApiResponse<Void>
 */
export const updateStudents = (body) => {
  return req.put(`/v1/students/classes/${body.classId}`, body.request);
};

/**
 * students - 학생 삭제하기 api
 * @param body
 * @returns ApiResponse<Void>
 */
export const deleteStudent = (body) => {
  return req.delete(`/v1/students/${body.studentId}/classes/${body.classId}`);
};

/**
 * students - 학생 아크수학 로그인 비밀번호 초기화 api
 * @param body
 * @returns ApiResponse<Void>
 */
export const initAccountPassword = (body) => {
  return req.put(`/v1/students/${body.studentId}/initAccountPassword`);
};

/**
 * students - 학생 Account 연결 해제 api
 * @param body
 * @returns ApiResponse<Void>
 */
export const unlinkStudentAccount = (body) => {
  return req.delete(`/v1/students/${body.studentId}/account`);
};

/**
 * students - Account 연동 실행 api
 * @param body
 * @returns ApiResponse<LinkAccountsResponse>
 */
export const linkAccounts = (body) => {
  return req.post(`/v1/students/link-accounts`, body);
};

/**
 * students - 학급별 학생과 연동 가능한 작년도 계정 조회 api
 * @param body
 * @returns ApiResponse<StudentWithPreviousAccountsResponse>
 */
export const getStudentsWithPreviousAccounts = (body) => {
  return req.get(`/v1/students/classes/${body.classId}/with-previous-accounts`);
};

// =================================================================
// 이용권 관리 api
// =================================================================
/**
 * licenses - 이용권 등록하기 api
 * @param body
 * @returns ApiResponse<Void>
 */
export const registrationVoucher = (body) => {
  return req2.post(`/v1/licenses/vouchers`, body);
};

/**
 * licenses - 현재 사용 가능한 이용권 내역 가져 오기 api
 * @param body
 * @returns ApiResponse<LicenseResponse>
 */
export const getActiveLicenses = (body) => {
  return req2.get(`/v1/licenses/teachers/${body.teacherId}`);
};

/**
 * licenses - 연도별 라이센스 리스트 가져오기 api
 * @param body
 * @returns ApiResponse<LicenseResponse>
 */
export const getLicensesListYear = (body) => {
  return req2.get(`/v1/licenses/teachers/${body.teacherId}/year`);
};

/**
 * licenses - 학생들에게 라이센스 적용하기
 * @param body
 * @returns ApiResponse<Void>
 */
export const setActiveLicenseStudents = (body) => {
  return req2.put(`/v1/licenses/${body.licenseId}/students`, body.request);
}

/**
 * licenses - 학생 1명 이용권 적용 해제
 * @param body
 * @returns ApiResponse<Void>
 */
export const removeLicenseStudent = (body) => {
  return req2.put(`/v1/licenses/students/${body.studentId}`);
}

/**
 * licenses - 학생 클래스 전체 이용권 적용 해제
 * @param body
 * @returns ApiResponse<Void>
 */
export const removeLicenseClassStudent = (body) => {
  return req2.put(`/v1/licenses/classes/${body.classId}`);
}

// =============================
// 방학 설정 테스트
// =============================

/**
 * licenses - 시간 등록하기
 * @param body
 * @returns ApiResponse<Void>
 */
export const setDateTimeState = (body) => {
  return req.post(`/v1/auth/dateTimeState`, body);
};

/**
 * licenses - 적용 시간 가져오기
 * @returns ApiResponse<LicenseResponse>
 */
export const getDateTimeState = () => {
  return req.get(`/v1/auth/dateTimeState`);
};



// ==========================================
// 소셜 로그인
// ========================================

/**
 * licenses - oAuth 로그인
 * @param body
 * @returns ApiResponse<Void>
 */
export const login = (body) => {
  return req.post(`/v1/auth/login`, body);
};

export const logout = (body) => {
  return req.post(`/v1/auth/logout`, {teacher: body.teacher, token: body.token});
}

export const reissue = (body) => {
  return req.post(`/v1/auth/reissue`, {accessToken: body.accessToken, refreshToken: body.refreshToken});
}

// ==========================================
// home
// ============================================
/**
 * home -홈데이터 가져오기
 * @returns ApiResponse<LicenseResponse>
 */
export const getHomeData = (body) => {
  return req.get(`/v1/home/teachers/${body.teacherId}`);
};

/**
 * home - 홈,숙제 진행중 데이터 가져오기
 * @returns ApiResponse<LicenseResponse>
 */
export const getHomeHomeworkData = (body) => {
  return req.get(`/v1/home/homework/teachers/${body.teacherId}`);
};

/**
 * home - 홈,숙제 종료된 숙제 데이터
 * @returns ApiResponse<LicenseResponse>
 */
export const getHomeHomeworkFinData = (body) => {
  return req.get(`/v1/home/homework/teachers/${body.teacherId}/finished?page=${body.page}&size=${body.size}`);
};

// ==========================================
// curriculum
// ============================================
/**
 * curriculum - 커리큘럼 버전 가져오기
 * @returns ApiResponse<LicenseResponse>
 */
export const getCurriculumVersion = () => {
  return req.get(`/v1/curriculum/version`);
};

/**
 * curriculum - 커리큘럼 데이터 가져오기
 * @returns ApiResponse<LicenseResponse>
 */
export const getCurriculumData = () => {
  return req.get(`/v1/curriculum/data`);
};

// ==========================================
// 선생님 관련 api
// ============================================

export const updateTeacherInfo = (body) => {
  return req.put(`/v1/teachers/${body.teacherId}`, body.request);
};